import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import EventGroupName from 'components/EventGroupName';

// Selectors
import { makeSelectDocumentSetValue } from 'services/documentSets/selectors';

interface Props {
    eventId?: number;
}

export class DocumentSetEventGroupName extends React.PureComponent<Props> {
    render() {
        const { eventId } = this.props;
        if (!eventId) return null;
        return <EventGroupName eventId={eventId} />;
    }
}

const mapStateToProps = createStructuredSelector({
    eventId: makeSelectDocumentSetValue('eventId')
});

export default connect(mapStateToProps)(DocumentSetEventGroupName);
